import { ShieldCheck, AlertCircle } from "lucide-react";
import { hasTool as has, cvText } from "../../lib/cvMatch";

export default function ToolsMatch({ app, testid = "tools-match" }) {
  const tools = app.job_tools || [];
  if (!tools.length) return null;
  const text = cvText(app.tailored_cv);
  const out = tools.filter((t) => !has(text, t));
  const n = tools.length - out.length;
  const all = !out.length;
  const Icon = all ? ShieldCheck : AlertCircle;
  return (
    <div className={`gi-card p-5 sm:p-6 border-l-[3px] ${all ? "border-l-success" : "border-l-warning"}`} data-testid={testid}>
      <div className="flex flex-wrap items-center gap-3">
        <span className={`inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full font-semibold text-sm ${all ? "bg-success-soft text-success" : "bg-warning-soft text-warning"}`} data-testid={`${testid}-badge`}>
          <Icon className="w-4 h-4" aria-hidden="true" /> {n} of {tools.length} job tools in your CV
        </span>
        <p className="text-[15px] text-body">{all ? "Every tool the job ad names is in your CV, so ATS filters can find it." : "Some tools from the job ad are no longer in your CV."}</p>
      </div>
      {!all && <p className="mt-3 text-sm text-body" data-testid={`${testid}-missing`}>Not in your CV: {out.join(", ")}</p>}
    </div>
  );
}
